import { createFeatureSelector } from '@ngrx/store';
import { NotificationsPopState } from './notifications-pop.model';
import { FEATURE_NAME } from './notifications-pop.constant';

export const selectNotificationPopState = createFeatureSelector<NotificationsPopState>(FEATURE_NAME);

